// Single sound-bars waveform geometry shared by every PlayingAnimation color
// and theme variant. The committed JSON ships one placeholder fill color; the
// rendered color is injected at runtime by `PlayingAnimation` (see
// buildSoundBars in ../../../components/animations/playing-animation/index.tsx).
import soundBars from '@rhg/../public/_n/animations/sound_bars.json';

export default soundBars;
